// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"37ae20cd","256":"2dabed1a","617":"428d08b1"}[chunkId] + ".chunk.js";
};